/**
 * Public storefront (eduw.in/<slug>): a customer orders from a restaurant
 * without logging in. The restaurant chosen by the link is kept for this
 * browser tab, so the ordering pages know which menu to show.
 */
export type Storefront = { restaurantId: string; slug: string; hotelName: string };

const KEY = "storefront";

export const getStorefront = (): Storefront | null => {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as Storefront) : null;
  } catch {
    return null;
  }
};

export const setStorefront = (storefront: Storefront) => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(storefront));
  } catch {
    /* storage unavailable — ordering still works for this page load */
  }
};

/** The guest "user" the ordering pages run as for a storefront restaurant. */
export const storefrontUser = (storefront: Storefront) => ({
  id: "guest",
  name: storefront.hotelName,
  email: "",
  role: "customer",
  restaurantId: storefront.restaurantId,
});
